module.exports = __webpack_public_path__ + "static/media/bxl-facebook-circle.42d574a2.svg";